/**
 * Scratch-related localStorage keys to remove when a user logs out.
 * Kept here (rather than inlined in the logout handler) so it can be unit
 * tested without pulling in Firebase.
 */

// Exact keys owned by the dashboard.
const STATIC_KEYS = ['settings', 'plaid-link-token', 'selectedPracticeId', 'capital_attribution']

// AG Grid state is stored under `<tableName>.column`, `<tableName>.gridFilter`,
// and `<tableName>.filter` — match those but require a non-empty alphanumeric
// prefix so we don't accidentally clobber keys from other apps on this origin.
const GRID_KEY_PATTERN = /^[A-Za-z0-9]+\.(column|gridFilter|filter)$/

export const isScratchLocalStorageKey = (key: string): boolean =>
	STATIC_KEYS.includes(key) || GRID_KEY_PATTERN.test(key)

/**
 * Removes all Scratch-related keys from localStorage so no cached
 * credentials, settings, or grid state survive after logout.
 */
export const clearScratchLocalStorage = (): void => {
	try {
		const keysToRemove: string[] = []

		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i)
			if (key && isScratchLocalStorageKey(key)) {
				keysToRemove.push(key)
			}
		}

		keysToRemove.forEach((key) => localStorage.removeItem(key))
	} catch (err) {
		console.warn('Failed to clear scratch localStorage:', err)
	}
}
